import { ApiKeyFields } from "types";

export const defaultValues = {
  [ApiKeyFields.title]: "",
  [ApiKeyFields.language]: "",
  [ApiKeyFields.iswc]: "",
};
